import { ThemeMapQuery } from 'common-types'
import ThemeMapGradesFSC from 'components/core-adoption/builder/ThemeMapGradesFSC'
import ThemeMapGradesMiddleSchool from 'components/core-adoption/builder/ThemeMapGradesMiddleSchool'
import calculateScrollHeight from 'components/core-adoption/functions/calculateScrollHeight'
import { Col, Row, Section } from 'components/grid'
import { H2 } from 'components/typography/Headings'
import { P } from 'components/typography/Paragraph'
import { CoreAdoptionContext } from 'context/CoreAdoption'
import { graphql, useStaticQuery } from 'gatsby'
import React, { useContext } from 'react'

const ThemeMapEnglishFSC = () => {
	const { account, language } = useContext(CoreAdoptionContext)
	const data = useStaticQuery<ThemeMapQuery>(query).contentfulThemeMap

	return (
		<Section margin="mt-14" id="recommended-unit-plan-english-middle-school" scrollMarginTop={calculateScrollHeight()}>
			<Row center>
				<Col>
					<div className="mx-auto mb-10 max-w-3xl text-center">
						<H2 className="text-balance mb-1">{language === 'english' ? <span>ARC Core</span> : 'ARC Core'}</H2>
						<span className="mb-2 block text-lg font-semibold italic">
							{language === 'english' ? 'Designed for 70-120 minute literacy blocks' : 'Diseñado para bloques de alfabetización de 70 a 90 minutos'}
						</span>
						<P>
							{language === 'english'
								? 'ARC Core includes four units per grade per year. Click on any theme below to review included materials. For more information, contact your ARC account manager.'
								: 'ARC Core en español incluye cuatro unidades por grado por año. Haga clic en un tema en el mapa temático siguiente recomendado para español para ver los materiales incluidos en esa Unidad.'}
						</P>
					</div>
				</Col>
			</Row>

			<Row>
				<Col>
					<ThemeMapGradesFSC data={data} language="english" grades={account ? account.english_grades_fsc : []} />
				</Col>
			</Row>
		</Section>
	)
}

const query = graphql`
	query {
		contentfulThemeMap(name: { eq: "Foundational Skills Compatible" }) {
			...coreAdoptionThemeMap
		}
	}
`

export default ThemeMapEnglishFSC
